import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

export const loginTenant = async (email: string, password: string, subdomain: string) => {
    const data = {
        "email": email,
        "password": password,
        "sub_domain": subdomain
    }
    const response = await api.post(API_ROUTES.AUTH.LOGIN, data);
    return response.data.data;
}